import { contactInfo } from '@/mocks/site';
import ContactForm from './ContactForm';

export default function ContactSection() {
  return (
    <section id="submit" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5 flex flex-col gap-5">
            <span className="inline-flex w-fit items-center gap-2 text-xs font-label font-medium tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-customer-service-2-line" aria-hidden="true" />
              联系方式
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              有线索、有疑问、想合作，都可以直接找我们
            </h2>
            <p className="text-sm md:text-base leading-relaxed text-foreground-600">
              编辑部会逐条阅读投稿与来信。为了更快进入核实流程，建议在投稿时尽量写清楚时间、地点与关键对话。
            </p>

            <div className="flex flex-col gap-3 mt-1">
              <div className="flex items-start gap-4 rounded-lg border border-background-300/60 bg-background-100/60 p-4 md:p-5">
                <span className="w-10 h-10 shrink-0 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className="ri-mail-line text-lg" aria-hidden="true" />
                </span>
                <div className="flex flex-col gap-1">
                  <p className="text-xs font-label text-foreground-500">投稿与线索</p>
                  <a href={`mailto:${contactInfo.email}`} className="font-heading text-base font-semibold text-foreground-950 hover:text-primary-700 transition-colors">
                    {contactInfo.email}
                  </a>
                  <p className="text-xs text-foreground-500">{contactInfo.replyTime}</p>
                </div>
              </div>
              <div className="flex items-start gap-4 rounded-lg border border-background-300/60 bg-background-100/60 p-4 md:p-5">
                <span className="w-10 h-10 shrink-0 rounded-lg bg-accent-100 text-accent-800 flex items-center justify-center">
                  <i className="ri-team-line text-lg" aria-hidden="true" />
                </span>
                <div className="flex flex-col gap-1">
                  <p className="text-xs font-label text-foreground-500">内容合作</p>
                  <a href={`mailto:${contactInfo.cooperation}`} className="font-heading text-base font-semibold text-foreground-950 hover:text-primary-700 transition-colors">
                    {contactInfo.cooperation}
                  </a>
                  <p className="text-xs text-foreground-500">媒体转载、联合选题与数据合作</p>
                </div>
              </div>
            </div>

            <div className="rounded-lg border border-primary-200 bg-primary-50 p-4 md:p-5">
              <p className="flex items-start gap-2 text-sm leading-relaxed text-primary-800">
                <i className="ri-information-line mt-0.5" aria-hidden="true" />
                为保护当事人隐私，请勿在表单中填写无关的身份证号、银行卡号等敏感信息。如确有必要，我们会在核实阶段与你确认安全的提交方式。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
}